import React from 'react';
import PropTypes from 'prop-types';
import ClientLeadNameView from './ClientLeadNameView';
import ClientLeadNameEdit from './ClientLeadNameEdit';

const ClientLeadName = (props) => {
  const [isEditing, setIsEditing] = React.useState(false);

  const {
    clientLeadData,
    clientLeadBackend,
  } = props;

  return (
    <>
      <ClientLeadNameView
        clientLeadData={clientLeadData}
        clientLeadBackend={clientLeadBackend}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
      />
      {
        isEditing &&
        <ClientLeadNameEdit
          clientLeadData={clientLeadData}
          clientLeadBackend={clientLeadBackend}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
        />
      }
    </>
  );
};

ClientLeadName.propTypes = {
  clientLeadData: PropTypes.object.isRequired,
  clientLeadBackend: PropTypes.object.isRequired,
};

export default React.memo(ClientLeadName);
